/**
 * 用户状态消息处理模块
 *
 * 职责：
 * 1. 处理金币同步消息（SYNC_COIN）
 * 2. 处理 VIP 变更消息（VIP_CHANGE）
 * 3. 处理账号注销提醒（SIGNOUT_REMIND）
 */

import { useUserStore } from '@/stores/user'

/**
 * 处理金币同步消息
 * @param {Object} event - EventBus 事件对象
 * @param {Object[]} event.data - IMManager 派发的消息数组
 */
export function handleSyncCoin() {
  // 刷新用户资产信息 TODO: 后续可以根据 change_num 修改内存中的金币数量，减少请求
  const userStore = useUserStore()
  userStore.fetchMemberAsset({ hideLoading: true, hideError: true })
}

/**
 * 处理 VIP 变更消息
 * @param {Object} event - EventBus 事件对象
 * @param {Object[]} event.data - IMManager 派发的消息数组
 */
export function handleVipChange() {
  const userStore = useUserStore()
  userStore.fetchUserInfo({ hideLoading: true, hideError: true })
}

/**
 * 处理账号注销提醒
 *
 * @param {Object} event - EventBus 事件对象
 * @param {Object[]} event.data - IMManager 派发的消息数组
 */
export async function handleSignoutRemind(event) {
  console.log('[SIGNOUT_REMIND] event', event)

  const userStore = useUserStore()

  // 2. 退出登录（清除 Token、用户信息、IM 数据等）
  await userStore.logout(true)
}
